// extracted by css-extract-rspack-plugin
export default {"page":"A97mEc7bBl8FRDgO","card":"ukt0pM55DjoygiKt","loading":"Qd5azUhWQRkpbjsl","signInButton":"kxalJSQhk_QebSNx"};